import { ValueOf } from 'common/types'

const Envs = {
  Local: 'LOCAL',
  Dev: 'DEV',
  Prod: 'PROD',
} as const

type Env = ValueOf<typeof Envs>

const getEnv = (): Env => {
  if (window.location.hostname.endsWith('.codes')) {
    return Envs.Dev
  }

  if (window.location.hostname === 'localhost') {
    return Envs.Local
  }

  return Envs.Prod
}

export const isLocal = () => getEnv() === Envs.Local
export const isDev = () => getEnv() === Envs.Dev
export const isProd = () => getEnv() === Envs.Prod
